export default {
  mediaGallery: 'Bank Gallery',
  createFolder: 'Create folder',
  upload: 'Upload',
  open: 'Open',
  remove: 'Remove',
  rename: 'Rename',
  cut: 'Cut',
  copy: 'Copy',
  paste: 'Paste',
  view: 'View',
  refresh: 'Refresh',
  fileName: 'File name',
  type: 'Type',
  folder: 'Folder',
  loading: 'Loading',
  folderName: 'Folder name',
  cantMoveFolderToItself: 'You can\'t move a folder inside itself.',
  newName: 'New name',
  nameAlreadyTaken: 'A folder or file with this name is already exist. Please try another name.',
  Type: 'Type'
}
